var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"test-div"},[_c('journey-map-edit')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }